export const sideMenuConfig = [
  {
    title: 'TOP',
    icon: 'mdi-file-document-edit-outline',
    children: [{ label: 'ポータル', route: '/', name: 'Portal' }]
  },
  {
    title: '検索メニュー',
    icon: 'mdi-file-document-edit-outline',
    children: [
      { label: '顧客検索', route: '/customer/list', name: 'CustomerList' },
      { label: '案件検索', route: '/matter/list', name: 'MatterList' }
    ]
  },
  {
    title: '登録メニュー',
    icon: 'mdi-file-document-edit-outline',
    children: [
      { label: '顧客登録', route: '/customer/register', name: 'CustomerRegister' },
      { label: '案件登録', route: '/matter/register', name: 'MatterRegister' }
    ]
  },
  {
    title: '管理者メニュー',
    icon: 'mdi-file-document-edit-outline',
    isAdmin: true,
    children: [
      { label: 'ユーザーマスタ登録', route: '/setting/employee/register', name: 'SettingEmployeeRegister' },
      { label: 'ユーザーマスタ検索', route: '/setting/employee/list', name: 'SettingEmployeeList' },
      { label: 'お知らせ情報マスタ登録', route: '/information/register', name: 'InformationRegister' },
      { label: 'お知らせ情報マスタ検索', route: '/information/list', name: 'InformationList' },
      { label: '連携ファイル出力', route: '/setting/management', name: 'SettingManagementView' }
      // TODO:20220906 FT様向けデモ用に非表示
      // { label: 'データエクスポート', route: '/dataexport/output', name: 'DataExportOutput' },
      // { label: '売粗（組織）エクスポート', route: '/dataexport/selling/organization', name: 'DataExportSellingOrganization' },
      // { label: '売粗（担当）エクスポート', route: '/dataexport/selling/representative', name: 'DataExportSellingRepresentative' }
    ]
  },
  {
    title: '設定メニュー',
    icon: 'mdi-file-document-edit-outline',
    isAdmin: true,
    children: [
      { label: '構成テンプ登録', route: '/materialtemplate/register', name: 'MaterialTemplateRegister' },
      { label: '構成テンプ検索', route: '/materialtemplate/list', name: 'MaterialTemplateList' }
    ]
  }
];

export interface MenuObject {
  title: string;
  icon: string;
  children: Array<ChildParam>;
}

interface ChildParam {
  label: string;
  route?: string;
}
